import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import MessageDiv from 'components/molecules/MessageDiv';
import { useSelectChatBottom } from 'modules/hooks';
import { useDispatch, useSelector } from 'react-redux';
import Feedback from 'components/molecules/Modal/Feedback';
import SelectBox from 'components/molecules/Modal/SelectBox';
import Dementia from 'components/molecules/Modal/Dementia';
import Voice from 'components/molecules/Voice';
import IosVoice from 'components/molecules/IosVoice';
import Organiz from 'components/molecules/Modal/Organiz';

/**
 * Chatting:Middle
 */
const ChatMiddle = ({ messageSet }) => {
  const feedbackModalStatus = useSelector(state => state.isActive.feedbackModal.status);
  const organizationStatus = useSelector(state => state.isActive.organizStatus);
  const voiceState = useSelector(state => state.isActive.voice);
  const iosvoiceState = useSelector(state => state.isActive.iosvoice);
  const selectBoxModalStatus = useSelector(state => state.selectBox.selectboxModal.selectStatus);
  const dementiaStatus = useSelector(state => state.dementia.dementiaboxModal.dementiaStatus);

  /*  window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition; */

  const messageBoxRef = useRef();
  useSelectChatBottom();

  return (
    <section className="_chat_middle">
      <div className="_message_div">
        <div className="_message_layout scroll_style_messenger" id="scrollToElement" ref={messageBoxRef}>
          {messageSet.map((item, idx) => {
            return <MessageDiv key={item.messageId} message={item} index={idx} />;
          })}
        </div>
      </div>
      <div className="_feedback_bg" style={{ display: feedbackModalStatus || voiceState ||iosvoiceState || selectBoxModalStatus || dementiaStatus || organizationStatus ? 'flex' : 'none' }}>
        {feedbackModalStatus && <Feedback />}
        {voiceState && <Voice />}
        {iosvoiceState && <IosVoice />}
        {selectBoxModalStatus && <SelectBox />}
        {dementiaStatus && <Dementia />}
        {organizationStatus && <Organiz />}
      </div>
    </section>
  );
};

ChatMiddle.propTypes = {
  messageSet: PropTypes.array,
};
ChatMiddle.defaultProps = {
  messageSet: [],
};
export default ChatMiddle;
